module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_iterators.js
// module id = 453
// module chunks = 1